export default __webpack_public_path__ + "static/Fooprint-6acec01a91005355ef98da7817452b3f.jpg";